import {
  SUGGESTED_PURCHASE_ORDER_INDEX_REQUESTED,
  SUGGESTED_PURCHASE_ORDER_INDEX_SUCCESS,
  SUGGESTED_PURCHASE_ORDER_INDEX_FAILURE,
  SUGGESTED_PURCHASE_ORDER_FIND_REQUESTED,
  SUGGESTED_PURCHASE_ORDER_FIND_SUCCESS,
  SUGGESTED_PURCHASE_ORDER_FIND_FAILURE,
  SUGGESTED_PURCHASE_ORDER_CREATE_REQUESTED,
  SUGGESTED_PURCHASE_ORDER_CREATE_SUCCESS,
  SUGGESTED_PURCHASE_ORDER_CREATE_FAILURE,
  SUGGESTED_PURCHASE_ORDER_MARK_COMPLETE_REQUESTED,
  SUGGESTED_PURCHASE_ORDER_MARK_COMPLETE_SUCCESS,
  SUGGESTED_PURCHASE_ORDER_MARK_COMPLETE_FAILURE,
} from '../types';

const INITIAL_STATE = {
  isFetching: false,
  isUpdating: false,
  status: 'waiting',
  activeSuggestedPurchaseOrder: null,
  suggestedPurchaseOrders: [],
  purchaseOrdersSearchStack: [''],
  errors: null,
  lastPage: true,
};

const suggestedPurchaseOrders = (state = INITIAL_STATE, action) => {
  const newState = { ...state };

  switch(action.type) {
    case SUGGESTED_PURCHASE_ORDER_INDEX_REQUESTED:
      return Object.assign({}, state, {
        isFetching: true,
        suggestedPurchaseOrders: [],
        status: 'requesting',
        errors: null,
      });

    case SUGGESTED_PURCHASE_ORDER_INDEX_SUCCESS:
      newState.isFetching = false;
      newState.status = 'success';
      newState.suggestedPurchaseOrders = action.payload.suggested_purchase_orders;
      newState.errors = null;
      newState.lastPage = action.payload.last_page;

      if(action.payload.continuation_token !== null) {
        newState.purchaseOrdersSearchStack[action.page] = action.payload.continuation_token;
      }

      return newState;


    case SUGGESTED_PURCHASE_ORDER_INDEX_FAILURE:
      return Object.assign({}, null, {
        isFetching: false,
        status: 'waiting',
        suggestedPurchaseOrders: [],
        errors: 'error here'
      });

    case SUGGESTED_PURCHASE_ORDER_FIND_REQUESTED:
      return Object.assign({}, state, {
        status: 'requesting',
        activeSuggestedPurchaseOrder: null,
        errors: null
      });

    case SUGGESTED_PURCHASE_ORDER_FIND_SUCCESS:
      return Object.assign({}, state, {
        status: 'success',
        activeSuggestedPurchaseOrder: action.payload
      });

    case SUGGESTED_PURCHASE_ORDER_FIND_FAILURE:
      return Object.assign({}, state, {
        status: 'waiting',
        errors: 'error here'
      });



    case SUGGESTED_PURCHASE_ORDER_CREATE_REQUESTED:
      newState.isUpdating = true;
      newState.errors = null;
      return newState;

    case SUGGESTED_PURCHASE_ORDER_CREATE_SUCCESS:
      newState.isUpdating = false;
      newState.suggestedPurchaseOrders.push(action.payload.new_suggested_purchase_order);
      return newState;

    case SUGGESTED_PURCHASE_ORDER_CREATE_FAILURE:
      newState.isUpdating = false;
      newState.errors = 'Failed to create suggested purchase order';
      return newState


    default:
      return state;
  }
}

export default suggestedPurchaseOrders;